import { render, staticRenderFns } from "./FileUploadDetails.vue?vue&type=template&id=29bcc03c"
import script from "./FileUploadDetails.vue?vue&type=script&lang=js"
export * from "./FileUploadDetails.vue?vue&type=script&lang=js"
import style0 from "./FileUploadDetails.vue?vue&type=style&index=0&id=29bcc03c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports